<template>
    <div>
            <BasicCard v-if="p_loading" v-bind:title="`Caricamento in corso`" class="pr-2">
                <v-card-text text-center>
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </BasicCard>
            <div v-else>
                <v-hover text-left v-if="!is_childcomponent"><v-chip 
                            slot-scope="{ hover }"
                            :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                            @click="close" absolute top left>
                            <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
                        </v-hover>
                <v-form ref="iform" v-model="valid" >
                    <BasicCard v-bind:title="`Anagrafica`" class="pr-2">
                        <v-container>
                        <v-row no-gutters>
                            <v-col cols="6" md="4">
                                <!-- <v-text-field dense outlined
                                    label="modello*"
                                    v-model="instrument.model"
                                    :rules="[rules.mandatory, rules.nameRules(instrument.model,2)]"
                                ></v-text-field> -->
                                <v-combobox dense outlined
                                    label="modello*"
                                    v-if="instrument.manufacturer"
                                    v-model="instrument.model"
                                    :items="models"
                                    required
                                    :rules="[rules.mandatory]"
                                ></v-combobox>  
                            </v-col>
                            <v-col cols="6" md="4" class="pl-2">
                                <!-- <v-text-field dense outlined
                                    label="marca*"
                                    v-model="instrument.manufacturer"
                                    :rules="[rules.mandatory, rules.nameRules(instrument.manufacturer,2)]"
                                ></v-text-field> -->
                                <v-combobox dense outlined
                                    label="marca*"
                                    v-if="manufacturers"
                                    v-model="instrument.manufacturer"
                                    :items="manufacturers"
                                    required
                                    item-text="text"
                                    item-value="val"
                                    @change="getModels"
                                    :rules="[rules.mandatory]"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6" md="4" class="pl-md-2">
                                <v-text-field dense outlined
                                    label="numero seriale*"
                                    v-model="instrument.serno"
                                    :rules="[rules.mandatory, rules.nameRules]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="pl-sm-2 pl-md-0">
                                <v-autocomplete dense outlined
                                    label="famiglia*"
                                    v-model="instrument.family"
                                    :items="Object.keys(families)"
                                    required
                                    :rules="[rules.mandatory]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" class="pl-md-2">
                                <v-text-field dense outlined
                                    label="nome/codice cliente"
                                    v-model="instrument.name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" v-if="showQRReader">
                                <qrcode-stream @init="onQRReaderInit" @decode="onQRDecode">
                                    <div class="loading-indicator" v-if="qr_loading">
                                        Loading...
                                    </div>
                                    <v-alert class="full-width" color="warning" dismissible v-if="smart_id_collision.length>0">
                                        Smart id già associato a: <br/>
                                        <ul><li v-for="item in smart_id_collision" :key="item.id"><b>{{item.value.serno}}</b> - <b>{{item.value.name}}</b> - <i>{{item.value.family}}</i></li></ul>
                                    </v-alert>
                                </qrcode-stream>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense outlined
                                    class="my-2"
                                    label="QRCode"
                                    v-model="instrument.qr_code"
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <!-- <v-col cols="6" class="d-flex flex-wrap justify-end">
                                <v-btn v-if="showQRReader" class="ma-2" text @click.stop="showQRReader=false">chiudi camera</v-btn>
                                <v-btn v-else @click.stop="readQRCode" class="ma-2"><span v-if="instrument.qr_code">modifica QRCode</span><span v-else>scansiona QRCode</span></v-btn>
                                <v-btn @click.stop="openEditQR" class="ma-2">inserisci manualmente</v-btn>
                            </v-col> -->
                            
                        </v-row>
                        </v-container>
                    </BasicCard>

                    <BasicCard v-bind:title="`Posizione`" class="pr-2" v-if="!primary">
                        <!--template v-slot:action><v-btn v-if="!c_lock" text @click.stop="changeClient"><v-icon>edit</v-icon> proprietario</v-btn></template-->
                        <v-container>
                            <v-row no-gutters v-if="enable_piva_search && !c_lock" >
                                <v-col cols="6" md="4">
                                    <v-btn class="my-2" color="action" @click="openPIVADialog"><v-icon small class="ma-1">search</v-icon>Partita IVA</v-btn>
                                </v-col>
                            </v-row>
                        <v-row no-gutters>
                            <v-col cols="6" md="4">
                                <v-autocomplete dense outlined
                                label="cliente*"
                                v-model="instrument.client_id"
                                :loading="c_loading"
                                clearable
                                :items="clients"
                                item-text="value.name"
                                item-value="_id"
                                @change="updateLocations"
                                :disabled="c_lock"
                                :rules="[rules.mandatory]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" md="4" v-if="!!instrument.client_id" class="pl-2">
                                <v-autocomplete dense outlined
                                label="sede*"
                                v-model="instrument.location_id"
                                :items="locations"
                                item-text="value.name"
                                item-value="_id"
                                clearable
                                :rules="[rules.mandatory]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" md="4" pl-2 v-if="!!instrument.client_id && departments.length > 0" class="pl-md-2">
                                <v-autocomplete dense outlined
                                label="reparto"
                                v-model="instrument.department_id"
                                :items="departments"
                                item-value="id"
                                item-text="name"
                                clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        </v-container>
                    </BasicCard>
                </v-form>
                <span v-if="instrument.family != undefined && instrument.family != null && instrument.family !=''">
                    <span v-if="families_obj[this.instrument.family]">
                        <BasicCard v-bind:title="`Dati per misure`">
                            <template v-slot:action>
                                <v-icon @click.stop="openTutorialDialog('instr')" class="suggestion white--text">help_outline</v-icon>
                                <v-btn text @click.stop="addPlatform" class="suggestion white--text"><v-icon small class="ma-1">add_box</v-icon>dispositivo</v-btn>
                            </template>
                            <InstrumentPlatforms
                                v-bind:init_platforms="instrument.platforms"
                                v-bind:family="instrument.family"
                                :selected_reports="metro_selected_type"
                                v-on:platform_validity="platformsChanged"
                                ref="platform_ref"
                            />
                        </BasicCard>
                        <BasicCard :title="`Dati metrologici`" v-if="handleMetroDisplay">
                            <template v-slot:action>
                                <v-icon @click.stop="openTutorialDialog('metro')" class="white--text">help_outline</v-icon>
                            </template>
                            <v-expansion-panels class="elevation-0 pa-0 ma-0" multiple v-model="metro_panels">
                                <MetrologicalInfo
                                    v-for="(op_type, index) of Object.keys(families_obj[instrument.family].report)"
                                    :key="op_type"
                                    v-bind:metro="instrument.metrological_info[op_type]"
                                    v-bind:type="op_type"
                                    v-bind:family="instrument.family"
                                    v-bind:title="report_obj[op_type].name"
                                    :selected="metro_selected[index]"
                                    :ref="`metro_${op_type}`"

                                >
                                    <template v-slot:selection>
                                    <div class="d-flex align-center justify-center flex-grow-0 flex-shrink-1">
                                        <v-checkbox dense v-model="metro_selected[index]" @click.stop.native @change="triggerExpansion(index)"/>
                                    </div>
                                    </template>
                                </MetrologicalInfo>
                            </v-expansion-panels>
                        </BasicCard>
                    </span>
                    <BasicCard :title="'Dati strumento primario'" v-if="primary">
                        <PrimaryData
                            v-bind:org_id="org_id"
                            v-bind:o_used_by="instrument.used_by"
                            v-bind:owner_lock="owner_lock"
                            v-bind:family="instrument.family"
                            v-bind:instrument_id="instrument._id"
                            v-bind:o_primary_data="instrument.primary_data"
                            v-on:primary_validity="primaryChanged"
                            ref="primary_ref"
                        >
                        </PrimaryData>
                    </BasicCard>
                </span>
                
                <v-alert class="my-4" v-if="errorMessage" type="warning">
                    {{errorMessage}} 
                </v-alert>
            
                <div class="d-flex align-center justify-center my-4">
                    <v-btn
                        class="ma-2"
                        @click="openSaveDefConfirm"
                        color="primary"
                        :disabled="(primary && $store.state.offline) || !isValid">
                        Salva
                    </v-btn>
                    <v-btn
                        class="ma-2 pl-2"
                        @click="submitUncomplete()"
                        v-if="valid && !isValid && !primary"
                        color="primary">
                        Salva incompleto
                    </v-btn>
                    <v-btn
                        class="ma-2 pl-2"
                        @click="close('cancel')" 
                        text
                    >
                    Annulla
                    </v-btn>
                </div>
            </div>
            <BaseDialog 
                :dialog="edit_qr.dialog"
                :max_width="`800`"
                @close_dialog="cancelEditQR">
                <template v-slot:title>
                    Inserimento manuale QRCode
                </template>
                
                <div class="d-flex flex-column align-baseline full-width">
                    <v-alert class="full-width" color="warning" dismissible v-if="smart_id_collision.length>0">
                        Smart id già associato a: <br/>
                        <ul><li v-for="item in smart_id_collision" :key="item.id"><b>{{item.value.serno}}</b> - <b>{{item.value.name}}</b> - <i>{{item.value.family}}</i></li></ul>
                    </v-alert>
                    <div class="d-flex full-width align-baseline justify-start">
                        <v-text-field dense outlined
                            label="qr code"
                            v-model="edit_qr.value"
                        />
                    </div>
                    <div class="d-flex full-width align-center justify-center my-4">
                        <v-btn color="primary" @click="saveEditQR">salva</v-btn>
                        <v-btn class="ml-2" text @click="cancelEditQR">annulla</v-btn>
                    </div>
                </div>       
            </BaseDialog>

            <BaseDialog
                :dialog="saveDef_confirm.dialog"
                v-on:close_dialog="closeConfirm">
                <template v-slot:title>
                    Aggiorna i dati
                </template>
                <div v-if="instrument.primary">
                    <div>
                        Vuoi aggiornare il primario?
                    </div>
                    <div class="d-flex align-center justify-center" >
                        <v-btn class="ma-2" color="primary" @click.stop="saveConfirm">conferma</v-btn>
                        <v-btn class="ma-2" text @click.stop="closeConfirm">annulla</v-btn>
                    </div>
            
                </div>
                <div v-else>
                    <div>
                        Vuoi sovrascrivere i dati?
                    </div>
                    <div class="d-flex align-center justify-center">
                        <v-btn class="ma-2" color="primary" @click.stop="saveConfirm">conferma</v-btn>
                        <v-btn class="ma-2" text @click.stop="closeConfirm">annulla</v-btn>
                    </div>
            
                </div>
            </BaseDialog>
            <BaseDialog
            :dialog="piva_dialog.open"
            v-on:close_dialog="closePIVADialog"
            :max_width="`800`"
            >
                <template v-slot:title>
                    Cerca per Partita IVA
                </template>
                <div>
                    <div class="text-h6">Ricerca nel sistema</div>
                        <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-text-field dense outlined
                                label="PIVA"
                                v-model="piva_dialog.search_piva"
                                :rules="[rules.piva]"
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-btn color="primary" class="d-flex align-content-center text-center" @click="exactSearch"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="piva_dialog.show_result">
                        <v-col cols="12">
                            <div v-if="!piva_dialog.result || piva_dialog.result.length == 0">Nessun risultato
                                <div class="d-flex align-center justify-center">
                                <v-btn class="ma-2" text @click.stop="closePIVADialog">chiudi</v-btn>
                                </div>
                            </div>
                            <div v-else-if="piva_dialog.result.length == 1">
                                {{piva_dialog.result[0].value.piva}} - {{piva_dialog.result[0].value.name}}
                                <div class="d-flex align-center justify-center">
                                    <v-btn class="ma-2" color="primary" @click.stop="closePIVADialog(piva_dialog.result[0].id)">scegli cliente</v-btn>
                                    <v-btn class="ma-2" text @click.stop="closePIVADialog()">annulla</v-btn>
                                </div>
                            </div>
                            <div v-else>
                                Anomalia nel sistema, contattare l'amministratore:
                                <div v-for="res of piva_dialog.result" :key="res.id">
                                    {{res.value.piva}} - {{res.value.name}}
                                </div>
                                <div class="d-flex align-center justify-center">
                                    <v-btn class="ma-2" text @click.stop="closePIVADialog()">annulla</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </BaseDialog>
            <TutorialDialog 
            :data="tutorial_dialog"
            @close_dialog="handleCloseDialog"
            />
        <!--ConfirmDialog
            v-bind:data="saveDef_confirm"
            v-on:close_dialog="closeConfirm"
            v-on:confirm_result="saveConfirm"/-->
    </div>
</template>
<script>
import InstrumentPlatforms from "./Instrument_utils/Instrument_platforms_new"
import BasicCard from '../../components/utils/Basic_card.vue'
import MetrologicalInfo from "./Instrument_utils/Metrological_info"
import PrimaryData from "./Instrument_utils/Primary_data"
import {searchByText, searchDesign, orderByFields} from "../../utils/dbUtility"
import BaseDialog from '../../components/dialogs/BaseDialog'
import TutorialDialog from '../../components/dialogs/TutorialDialog'

import {i_families, report_type, tutorial_messages} from "../../utils/common.js"
import { getFamilies, filterByOrg } from "../../utils/rolesManagement"
import { getModel } from '../../utils/model'
import { f_rules } from '../../utils/commonUtils'
import { editPrimary } from '../../utils/rolesManagement'
import { QrcodeStream} from 'vue-qrcode-reader'

// import _ from 'lodash'

export default {
    components: {InstrumentPlatforms, MetrologicalInfo, BasicCard, PrimaryData, BaseDialog, QrcodeStream, TutorialDialog},
    props: {
        back: {
            type: String,
            required: false,
            default: "/instruments/"
        },
        instrument_id: {
            type: String,
            required: false,
            default: null
        },
        client_id: {
            type: String,
            required: false,
            default: null
        },
        location_id: {
            type: String,
            required: false,
            default: ""
        },
        department_id: {
            type: String,
            required: false,
            default: null
        },
        lock_client: {
            type: Boolean,
            required: false,
            default: false
        },
        clone: {
            type: Boolean,
            required: false,
            default: false
        },
        is_childcomponent: {
            type: Boolean,
            required: false,
            default: false
        },
        primary: {
            type: Boolean,
            required: false,
            default: false
        },
        org_id: {
            type: String,
            required: false,
            default: null
        },
        owner_lock:{
            type: Boolean,
            required: false,
            default: false
        }

    },
    
    data() {
        return {
            inst_new: true, 
            p_loading:false,
            valid: false,
            name: "",
            instrument: {},
            clients: [],
            locations: [],
            location_ref: null,
            departments: [],
            c_loading: false,
            client_search:'',
            rules: f_rules,
            op_types: [],
            families_obj: i_families,
            families: {},
            manufacturers: [],
            models: [],
            manufacturers_full: [],
            report_obj: report_type,
            search: null,
            roles: this.$store.state.user.roles,
            platforms_validity: false,
            primary_validity: false,
            c_lock: false,
            saveDef_confirm: {
                index: null,
                dialog: false,
                doc: null,
                title: 'Aggiorna dati',
                message: "Vuoi sovrascrivere i dati?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "confirm", val: "Conferma"}
                    ]
            },
            metro_panels: [],
            metro_selected: [],
            overwrite: false,
            enable_piva_search: false,
            piva_dialog: {
                open: false,
                search_piva: "",
                result: null,
                show_result: false
            },
            errorMessage: null,
            showQRReader: false,
            qr_loading: false,
            smart_id_collision: [],
            edit_qr: {
                dialog: false,
                value: ""
            },
            tutorial_dialog: {
                dialog: false,
                message: "Messaggio di default"
            },
            def_org_id: null
        }
    },
    created(){
        // this.debouncedClient = _.debounce(function(){
        //     // console.log('debouncedClient')
        //     this.searchClient()
        // },300)
        this.op_types = Object.keys(this.report_obj)
    },
    watch: {
        'client_search': {
            handler() {
                if (this.client_search && this.client_search.trim()!='') {
                    this.debouncedClient()
                }
            }
        },
        'instrument.family': {
            handler() {
                if (!this.instrument.family) {
                    return
                }
                console.log('family', this.instrument.family)
                if (this.instrument.platforms == undefined || this.instrument.platforms == null) {
                    console.log('empty instrument.data')
                    this.instrument.platforms = []
                }
            }
        },
        'instrument.location_id': {
            async handler() {
                if (this.instrument.location_id){
                    this.location_ref = await this.$store.state.$pouch.get('registry', this.instrument.location_id)
                    this.departments = Object.values(this.location_ref.departments)   
                } else {
                    this.instrument.location_id = ""
                    this.departments = []
                }
            }
        }
    },
    async mounted(){
        console.log('§§§§§§§§§§§§§§ EDIT', this.lock_client)
        this.enable_piva_search = filterByOrg('client', 'view_org', this.$store.state.user.roles)
        await this.initInstrument()
        // if (this.families_obj[this.instrument.family]) {
        //     let metro_type = Object.keys(this.families_obj[this.instrument.family].report)
        //     for (let i=0; i<metro_type.length; i++) {
        //         if (this.isMetroSelected(this.instrument.metrological_info[metro_type[i]])) {
        //             this.metro_panels.push(i)
        //             this.metro_selected.push(true)
        //         } else {
        //             this.metro_selected.push(false)
        //         }
        //     }
        // }
        // this.c_lock = this.lock_client
        this.errorMessage = null
        // this.$nextTick(()=>{
        //     this.$refs.iform.validate()
        // })
    },
    methods: {
        getSmartId(data) {
            let smart_id = decodeURIComponent(data)
            
            let match = this.$store.state.config.qrcode.prefixes.reduce((cur, p) => { 
                let a = data.startsWith(p) && p.length>cur.length ? p : cur
                return a
            }, "")
            return smart_id.substring(match.length)
        },
        readQRCode() {
            this.showQRReader = true
        },
        async onQRDecode(code) {
            this.instrument.qr_code = null
            this.smart_id_collision = []
            let smart_id = this.getSmartId(code)
            console.log("CODE", code, smart_id)
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', ["qr_code", smart_id], false)
            console.log("collision", res)
            
            if (res!=undefined && res!=null && res.length>0) {
                this.smart_id_collision = res
                console.log('instruments', res)
            } else  {
                this.smart_id_collision = []
                this.instrument.qr_code = smart_id
                this.showQRReader = false
            }
        },
        async onQRReaderInit(promise) {
            try {
                this.qr_loading = true;
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                this.error = "ERROR: you need to grant camera access permission"
                } else if (error.name === 'NotFoundError') {
                this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                this.error = "ERROR: Stream API is not supported in this browser"
                } else if (error.name === 'InsecureContextError') {
                this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
                } else {
                this.error = `ERROR: Camera error (${error.name})`;
                }
            } finally {
                this.qr_loading = false;
            }
        },
        openEditQR(){
            this.smart_id_collision = []
            this.showQRReader = false
            this.edit_qr.dialog = true
        },
        cancelEditQR() {
            this.edit_qr.dialog = false
            this.edit_qr.value = ""
        },
        async saveEditQR() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', ["qr_code", this.edit_qr.value.trim()], false)
            console.log("collision", res)
            if (res!=undefined && res!=null && res.length>0) {
                this.smart_id_collision = res
                console.log('instruments', res)
            } else  {
                this.smart_id_collision = []
                this.instrument.qr_code = this.edit_qr.value.trim()
                this.cancelEditQR()
            }
        },
        
        reset() {
            this.$refs.iform.reset();
            this.errorMessage = null
        },
        
        async initInstrument() {
            this.instrument = {}
            this.showQRReader = false
            this.qr_loading = false
            this.smart_id_collision = []
            this.p_loading = true
            this.inst_new = true
            this.errorMessage = null
            console.log("********** this.org_id", this.org_id)
            await this.getManufacturers()
            if (this.org_id) {
                this.def_org_id = this.org_id
            } else {
                this.def_org_id = this.$store.state.user.org_id
            }
            if (this.instrument_id) {
                let o_instrument = await this.$store.state.$pouch.get('registry', this.instrument_id)
                this.setManuModel()
                if (this.clone) {
                    console.log('instrument before', this.instrument)
                    let Instrument = getModel("Instrument")
                    // this.instrument = Instrument()
                    delete o_instrument._id
                    delete o_instrument.serno
                    delete o_instrument.complete
                    if (!this.lock_client) {
                        delete o_instrument.client_id
                    }
                    delete o_instrument.location_id
                    delete o_instrument.department_id
                    delete o_instrument.name
                    delete o_instrument.qr_code
                    delete o_instrument._rev
                    delete o_instrument.created
                    delete o_instrument.updated
                    for (let key in o_instrument.metrological_info) {
                        // reset metro info
                        if (this.isMetroSelected(o_instrument.metrological_info[key])) {
                            o_instrument.metrological_info[key].last_operation = 0
                            o_instrument.metrological_info[key].next_operation = 0
                        }
                    }
                    // reset primary info
                    if (o_instrument.primary) {
                        o_instrument.primary_data.certificate_ref = ''
                        o_instrument.primary_data.certificate_nr = ''
                        o_instrument.primary_data.emission = 0
                        o_instrument.primary_data.expire = 0
                        
                    }
                    o_instrument.created_by = this.$store.state.user._id
                    console.log("INSTRUMENT", o_instrument)
                    // _.merge(this.instrument, o_instrument)
                    try {
                        this.instrument = Instrument(o_instrument)
                    } catch (error) {
                        console.log("**************",error)
                        this.instrument = Instrument()
                        _.merge(this.instrument, o_instrument)
                    }
                    console.log("INSTRUMENT", this.instrument)
                    
                } else {
                    this.inst_new = false
                    this.instrument = o_instrument
                }
            } else {
                this.createInstrument();
                if (this.client_id){
                    this.instrument.client_id = this.client_id
                }
                if (this.location_id){
                    this.instrument.location_id = this.location_id
                    if (this.department_id) {
                        this.instrument.department_id = this.department_id
                    } 
                }
            }
            this.families = getFamilies(this.primary)
            
            if (!this.instrument.primary && this.instrument.client_id) {
                let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', this.instrument.client_id, false)
                if (res != null) {
                    this.clients = res.map(item => { return { _id: item.id, value: item.value } })
                    console.log('clients', this.clients)
                }
                await this.updateLocations()

                for (let l of this.locations){
                    if(l._id === this.instrument.location_id){
                        this.location_ref = l;
                    }
                }
            } else if (!this.instrument.primary) {
                this.getClients()
            }
            // if (this.primary) {
            //     this.families = getFamilies(this.primary)
            // }
            if (this.families_obj[this.instrument.family]) {
                let metro_type = Object.keys(this.families_obj[this.instrument.family].report)
                for (let i=0; i<metro_type.length; i++) {
                    if (this.isMetroSelected(this.instrument.metrological_info[metro_type[i]])) {
                        this.metro_panels.push(i)
                        this.metro_selected.push(true)
                    } else {
                        this.metro_selected.push(false)
                    }
                }
            }
        
            this.p_loading = false
            this.$nextTick(()=>{
                this.$refs.iform.validate()
            })
            this.c_lock = this.lock_client
        },
        async getManufacturers(){
            let selector = {
                "doc_type": "manufacturer"
            }
            let temp = []
            let res = await this.$store.state.$pouch.find("masters", {selector:selector, limit: 1000})
            for(let one in res.docs){
                if("name" in res.docs[one]){
                    temp.push({"text": res.docs[one]['name'], "val": res.docs[one]})
                }
            }
            this.manufacturers = temp
            this.manufacturers_full = res.docs
        },
        setManuModel(){
            console.log("CHECK MODELLO E PRODUTTORE!!!!!!")
            this.instrument.standard_manufacturer = null
            this.instrument.standard_model = null
            for(let one of this.manufacturers){
                if(this.instrument.manufacturer == one['text']){
                    console.log("TROVATO!!!!", one)
                    this.instrument.manufacturer = one
                    this.instrument.standard_manufacturer = one['val']['external_id']
                    this.getModels()
                    break
                }
            }
            for(let one of this.models){
                if(this.instrument.model == one['text']){
                    this.instrument.model = one
                    this.instrument.standard_model = one['val']['external_id']
                    break
                }
            }
        },
        getModels(){
            this.models = []
            if (this.instrument.manufacturer instanceof String){
                return []
            }
            for(let one in this.manufacturers_full){
                if(this.instrument.manufacturer['val']['external_id'] == this.manufacturers_full[one]["external_id"]){
                    console.log("TROVATO!")
                    for (let two of this.manufacturers_full[one]['models']){
                        this.models.push({"text": two['name'], "val": two})
                    }
                    return
                }
            }
        },
        isMetroSelected(metro) {
            return metro && !_.isEmpty(metro)
        },
        triggerExpansion(index) {
            if(this.metro_selected[index]) {
                this.metro_panels.push(index)
            } else {
                this.metro_panels.splice(this.metro_panels.indexOf(index), 1)
            }
        },
        changeClient() {
            this.c_lock = false
        },
        editPrimary(){
            return editPrimary(this.$store.state.user.roles)
        },
        addPlatform(){
            this.$refs.platform_ref.addPlatform()
        },
        createInstrument(){
            this.clear()
            let MetrologicalInfo = getModel("MetrologicalInfo")
            let Instrument = getModel("Instrument")
            this.instrument = Instrument({
                created_by: this.$store.state.user._id,
                metrological_info: MetrologicalInfo(),
                primary: this.primary
            })
        },
        setInstrDepartment() {
            if (this.instrument.department_id==undefined){
                this.instrument.department_id = ""
            }
        },
        setStandardModels(){
            if(!((typeof this.instrument.manufacturer) === 'string')){
                console.log("AO", this.instrument.manufacturer)
                this.instrument.standard_manufacturer = this.instrument.manufacturer['val']['external_id']
                this.instrument.manufacturer = this.instrument.manufacturer['text'] 
            }
            if(!((typeof this.instrument.model) === 'string')){
                console.log("AO", this.instrument.model)
                this.instrument.standard_model = this.instrument.model['val']['external_id']
                this.instrument.model = this.instrument.model['text'] 
            }
        },
        async exactSearch(){
            this.piva_dialog.show_result = false
            this.piva_dialog.result = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['piva', this.piva_dialog.search_piva], false)
            this.piva_dialog.show_result = true
        },
        closePIVADialog(client) {
            //console.log("************", client)
            if (client) {
                let added_client = {_id: this.piva_dialog.result[0].id, value: this.piva_dialog.result[0].value}
                this.$set(this.clients, this.clients.length, added_client)
                this.$set(this.instrument, 'client_id', this.piva_dialog.result[0].id)
                this.searchLocations(this.instrument.client_id)
            }
            this.piva_dialog.open = false
            this.piva_dialog.show_result = false
        },
        openPIVADialog() {
            this.piva_dialog.search_piva = ""
            this.piva_dialog.open = true
            this.piva_dialog.result = null
            
        },
        async getClients() {
            let selectors = ['client']
            if (!filterByOrg('client', 'list', this.$store.state.user.roles)) {
                selectors.push(['org', this.$store.state.user.org_id])
            }
            
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'all_keys', selectors, false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.clients = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.clients = []
            }
            if (this.client_id) {
                await this.searchLocations(this.client_id)
            }
        },
        // async searchClient(){
        //     // serch by name - ispettori interni
        //     if (this.client_search != undefined && this.client_search.trim()!= '' && this.client_search.trim().length > 2){
        //         this.c_loading = true
        //         let res = await searchByText(this.$store.state.$pouch, 'registry', 'clients/searchByText', this.client_search)
        //         if (res != null) {
        //             this.clients = res
        //         }
        //         this.c_loading = false
        //     }
        //     // search by PIVA
        //     /* if (this.ext_data.client.search != undefined && this.ext_data.client.search.trim()!= ''){
        //         let res = await this.$store.state.$pouch.find('registry', {selector: {doc_type: 'client', piva: this.ext_data.client.search}) // da sostitire con search su view
        //         if (res != null) {
        //             this.s_clients = res
        //         }
        //      }*/
        // },
        async searchLocations(id){
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', id], false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                // console.log('res -', res)
                this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.locations = []
            }
            console.log('locations', this.locations)
        },

        close(type){
            console.log("DEBUG, back path", this.back, type)
            this.showQRReader = false
            this.qr_loading = false,
            this.smart_id_collision = []
            if(!this.is_childcomponent) {
                this.$router.push({path: this.back})
            } else {
                console.log('debug', type)
                switch(type) {
                    case 'cancel':
                        console.log('debug', type)
                        this.$emit('close_dialog')
                        break;
                    case 'save':
                        this.$emit('update_instrument', this.instrument._id)
                        break;
                }
            }
        },
        async submitUncomplete() {
            this.errorMessage = null
                
            for (let op_type of Object.keys(this.families_obj[this.instrument.family].report)) {
                this.instrument.metrological_info[op_type] = this.$refs['metro_'+op_type][0].getData();
            }
            if(this.$refs.platform_ref && this.$refs.platform_ref.platforms){
                // this.instrument.platforms = this.$refs.platform_ref.platforms;      //TODO check functionalities
                this.instrument.platforms = this.$refs.platform_ref.getPlatforms()     //TODO check functionalities
                this.processComplete()
            }
            this.setInstrDepartment()
            console.log("check platform before save", this.instrument)

            try{
                this.instrument.updated_by = this.$store.state.user._id
                this.instrument.updated = (new Date()).getTime()
                let res = await this.$store.state.$pouch.put('registry', this.instrument)
                console.log("DEBUG, insert result", res)
                if(res.ok){
                    this.close('save')
                }
                this.$store.commit("showSnackbar", {text: "Strumento salvato con successo", color: 'primary'})
            } catch(err) {
                this.errorMessage = "Salvataggio fallito - riprovare. Se il problema persiste contattare l'amministratore"
                console.log("ERROR", err)
            }
        },
        openSaveDefConfirm() {
            if (!this.inst_new && this.instrument.complete) {
                this.saveDef_confirm.dialog = true
            } else {
                this.submit()
            }
        },
        closeConfirm() {
            console.log('CLOSING CONFIRM DIALOG')
            this.saveDef_confirm.dialog = false
            console.log('CLOSED CONFIRM DIALOG')
            
        },
        saveConfirm() {
            this.submit()
            this.closeConfirm()
        },
        async submit() {
            if(this.handleMetroDisplay){
                for (let op_type of Object.keys(this.families_obj[this.instrument.family].report)) {
                    this.instrument.metrological_info[op_type] = this.$refs['metro_'+op_type][0].getData();
                }
            }
            this.setInstrDepartment()
            this.setStandardModels()
            console.log("instrument", this.instrument)
            let docs_to_save = [this.instrument]
            this.instrument.updated_by = this.$store.state.user._id
            this.instrument.updated = (new Date()).getTime()
                
            if(this.primary) {
                this.instrument.primary_data = this.$refs.primary_ref.getData()
                if (this.instrument.used_by != this.$refs.primary_ref.used_by  || this.instrument.org_id != this.$refs.primary_ref.owner) {
                    let PrimaryLoanOp = getModel("PrimaryLoanOp");
                    let loanObj = PrimaryLoanOp({
                        instrument_id: this.instrument._id,
                        org_id: this.$refs.primary_ref.owner,
                        used_by: this.$refs.primary_ref.used_by,
                        note: this.$refs.primary_ref.note,
                        created_by: this.instrument.updated_by,
                        created: this.instrument.updated
                    })
                    
                    docs_to_save.push(loanObj)
                    
                }
                this.instrument.org_id = this.$refs.primary_ref.owner
                this.instrument.used_by = this.$refs.primary_ref.used_by
            }
            if(this.$refs.platform_ref && this.$refs.platform_ref.platforms){
                this.instrument.platforms = this.$refs.platform_ref.getPlatforms()     //TODO check functionalities
                if(this.handleMetroDisplay){
                    this.processComplete()
                }
            }
            try{
                let save_all = true
                this.errorMessage = null
                
                if(this.primary){
                    let test = await this.axios.post("/mastercal/instruments/history", {...this.instrument}).catch(error => {
                        console.log("error status", error);
                        save_all = false
                        this.dialogUpdatePw.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
                    });
                    //{...this.instrument})
                    console.log("risultato axios", test)
                } else {
                    let client = await this.$store.state.$pouch.get('registry', this.instrument.client_id)
                    if(!client.ref_orgs.includes(this.def_org_id)){
                        client.ref_orgs.push(this.def_org_id)
                    }
                    for (let loc of this.locations) {
                        let location = await this.$store.state.$pouch.get('registry', loc._id)
                        if(!location.ref_orgs.includes(this.def_org_id)){
                            location.ref_orgs.push(this.def_org_id)
                        }
                        docs_to_save.push(location)
                        
                    }    
                    if(!this.instrument.ref_orgs.includes(this.def_org_id)){
                        this.instrument.ref_orgs.push(this.def_org_id)
                    }
                    docs_to_save.push(client)
                }
                if (save_all) {
                    let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
                
                    this.$root.$emit('remote_operation_update', {type: 'instrument', state:true, instr_id: this.instrument._id})
                    console.log("DEBUG, insert result", res)
                    if(res[0].ok){
                        this.close('save')
                    }
                    this.$store.commit("showSnackbar", {text: "Strumento salvato con successo", color: 'primary'})
                }
            } catch(err) {
                this.errorMessage = "Salvataggio fallito - riprovare. Se il problema persiste contattare l'amministratore"
                console.log("ERROR", err)
            }
        },
        clear() {
            if (this.$refs.iform){
                this.$refs.iform.reset();
            }
            this.metro_selected = []
            this.metro_panels = []
            this.instrument.platforms = null; // TODO data => platforms
            this.instrument.primary_data = null;
        },
        async updateLocations(){
            await this.searchLocations(this.instrument.client_id);
        },
        /*validate(){
            if(this.instrument.family){
                console.log("validate", this.$refs.platform_ref)
                if(this.$refs.platform_ref && this.$refs.platform_ref.valid){
                    console.log("PLATFORM DEFINED", this.$refs.platform_ref.valid , "valore valid form", this.valid)
                    return this.$refs.platform_ref.valid && this.valid;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },*/
        validate() {
            console.log("validate", this.isValid, this.instrument_id, this.$refs.iform)
            console.log(this.isValid && !!this.instrument_id && !!this.$refs.iform)
            //if (!this.isValid && !!this.instrument_id && !!this.$refs.iform) {
                console.log('trigger validation')
                this.$refs.iform.validate()
                this.$refs.platform_ref.validate()
            //}
        },
        platformsChanged(validity){
            this.platforms_validity = validity
        },
        primaryChanged(validity){
            console.log("validità campione aggiornata", validity)
            this.primary_validity = validity
        },
        processComplete(){
            let CompleteCheck = getModel("CompleteCheck")

            let instr_validity = {}
            _.forEach(this.op_types, o=> instr_validity[o]=this.isValid)
            this.instrument.complete = CompleteCheck(
                instr_validity
            )
            if (!this.isValid) {
                return
            }
            let custom_platforms_validity = this.$refs.platform_ref.getPlatformsValidity()

            for (let op_type in this.families_obj[this.instrument.family].report) {
                let metro_valid = this.$refs['metro_'+op_type][0].isValid()
                this.instrument.complete[op_type] = this.instrument.complete[op_type] && custom_platforms_validity[op_type] && metro_valid
            }
        },
        handleCloseDialog() {
            this.tutorial_dialog.dialog = false;
        },
        openTutorialDialog(type){
            if(type == "instr"){
                console.log("tutorial dialog strumento", tutorial_messages[type])
            } else if(type == "metro"){
                console.log("tutorial dialog metrodata", tutorial_messages[type])
            }
            this.tutorial_dialog.dialog = true
            this.tutorial_dialog.message = tutorial_messages[type]
        }
    },
    computed: {
        isValid() {
            let valid = false
            console.log('******************* VALIDATE_CHECK')
            if(this.instrument.family){
                if(this.primary){
                    if(this.family_uom){
                        valid = this.platforms_validity && this.valid && this.primary_validity
                    } else {
                        valid = this.valid && this.primary_validity
                    }
                } else {
                    valid = this.platforms_validity && this.valid;
                }
            } 
            return valid
        },
        
        handleMetroDisplay(){
            if(this.primary && this.instrument.family != "bilancia nawi"){
                return false
            } else {
                return true
            }

        },
        metro_selected_type() {
            let metro_type = Object.keys(this.families_obj[this.instrument.family].report)
            let metro_selected_type = []
            for (let i=0; i<metro_type.length; i++) {
                if(this.metro_selected[i]){
                    metro_selected_type.push(metro_type[i])    
                }
            }
            console.log("metro_selected_type", metro_selected_type )
            return metro_selected_type
        }
    },
}
</script>

<style>

</style>
